import { isInsideViewport, isElVisibleInsideCarousel } from '../../utility/utility_controller'

var arrayElIsTrue = function (element, index, array) {
	return element == true
}

var waitForInviewImagesLoaded = function ($content, callback) {
	var imagesInViewport = []
	var imagesInViewportHaveLoaded = []

	// images in marquee element dont get classes like "loaded" or "lazyloaded", so we dont watch them
	// dont check for any images that dont get a loaded or lazyloaded class!
	// taken from "el_functions.php"!
	$content.find('img.lazyload, img.lay-gif, img.lay-image-original, img.setsizes, img.lay-image-responsive, img.carousel-img').each(function () {
		if (this.classList.contains('carousel-img')) {
			if (isInsideViewport(this)) {
				var lay_carousel = this.closest('.lay-carousel')
				if (lay_carousel.classList.contains('transition-fading') || lay_carousel.classList.contains('transition-immediate')) {
					var slide = this.closest('.lay-carousel-slide')
					// only wait for image of currently shown slide to have loaded
					if (slide.classList.contains('is-selected')) {
						imagesInViewport.push(this)
						imagesInViewportHaveLoaded.push(false)
					}
				} else {
					// transition swipe
					if (isElVisibleInsideCarousel(lay_carousel, this, -80)) {
						imagesInViewport.push(this)
						imagesInViewportHaveLoaded.push(false)
					}
				}
			}
		} else {
			if (isInsideViewport(this)) {
				imagesInViewport.push(this)
				imagesInViewportHaveLoaded.push(false)
			}
		}
	})

	// no images? done!
	if (imagesInViewport.length == 0) {
		callback()
		return
	}

	// seems that on firefox, sometimes images dont get the lazyloaded class set, when magneticslides is active and we went forward with browser button, so im adding it myself in this edge case:
	if (jQuery('html').hasClass('fp-enabled')) {
		var isFirefox = navigator.userAgent.toLowerCase().includes('firefox')
		if (isFirefox) {
			imagesInViewport.forEach(function (img) {
				if (img.classList.contains('lazyload')) {
					img.classList.add('lazyloaded')
				}
			})
		}
	}

	for (var i = 0; i < imagesInViewport.length; i++) {
		;(function (index) {
			var $img = imagesInViewport[index]
			if ($img.classList.contains('lazyloaded') || $img.classList.contains('loaded') || $img.classList.contains('loaded-error')) {
				imagesInViewportHaveLoaded[index] = true
			} else {
				// wait until image gets the loaded or lazyloaded class
				var observer = new MutationObserver(() => {
					if ($img.classList.contains('lazyloaded') || $img.classList.contains('loaded') || $img.classList.contains('loaded-error')) {
						imagesInViewportHaveLoaded[index] = true
					}
				})
				observer.observe($img, { attributes: true, attributeFilter: ['class'] })
			}
		})(i)
	}

	if (imagesInViewport.length > 0) {
		// cant take longer than 2.5 seconds!
		var t = setTimeout(function () {
			callback()
			clearInterval(interval)
		}, 2500)

		var interval = setInterval(function () {
			// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/every
			if (imagesInViewportHaveLoaded.every(arrayElIsTrue)) {
				callback()
				clearInterval(interval)
				clearTimeout(t)
			}
		}, 30)
	} else {
		callback()
	}
}

export { waitForInviewImagesLoaded }
